import styled from "@emotion/styled";
import {FormProps, FormStyleFn} from "./utils";

const fontSize: FormStyleFn<string> = ({crossBrand, theme}) =>
  !crossBrand && ["gap", "gapfs", "br", "brfs"].includes(theme.brand)
    ? "0.75rem"
    : "0.8125rem";

const Note = styled.div<FormProps>`
  display: block;
  font-size: ${fontSize};
  line-height: 1.2;
  margin-top: 0.25rem;
`;

export default Note;
